import { ActionsPlanTypes } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import { IJBPActualsAndTargetsCategory } from 'legacy/lut/services/partner360/common/models/jbpActualsAndTargetsCategories'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import { getTranslatedKeyInitiativeStatusOptions } from 'partner360/entities/keyInitiatives/model/status'
import { TInvestmentSourceValue } from 'partner360/features/keyInitiativeEditor/model/modalTypes'

import { STATUS_OPTIONS } from '../../configs'

export const MAX_INITIATIVE_NAME_LENGTH = 30

export const investmentSources: Array<{ value: TInvestmentSourceValue }> = [
  { value: ActionsPlanTypes.Opex },
  { value: ActionsPlanTypes.DGF },
  { value: ActionsPlanTypes.MDF },
  { value: 'Alliance Funds' },
]

export const createBusinessUnitsCrud = (businessUnits: IJBPActualsAndTargetsCategory[]) => {
  return new Crud({
    fetcher: new Static(businessUnits),
    keyField: 'Category',
    defaultPaging: {
      page: 0,
      pageSize: businessUnits.length,
    },
  })
}

export const createInvestmentSourceCrud = () => {
  return new Crud({
    fetcher: new Static(investmentSources),
    keyField: 'value',
    defaultPaging: {
      page: 0,
      pageSize: investmentSources.length,
    },
  })
}

export const createStatusCrud = (translate: (key: string) => string = (key) => key) => {
  return new Crud({
    fetcher: new Static(
      getTranslatedKeyInitiativeStatusOptions(translate).sort((a, b) => a.key.localeCompare(b.key))
    ),
    keyField: 'key',
    defaultPaging: {
      page: 0,
      pageSize: STATUS_OPTIONS.length,
    },
  })
}

export const getActivityTypeCrud = () => {
  const crud = CrudStore.get('Dropdowns', 'ActivityType')
  crud.setRoot('KIActivityType')
  return crud
}
